module.exports = __webpack_public_path__ + "static/media/raid_servers_5.51dec0ce.jpg";